import React from 'react';
import { Button, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
// Helpers
import { LocationFilterValues } from 'helpers/externalTalents';
// Styles
import styles from '../../ExternalTalents.module.scss';

type LocationFilterDropdownProps = {
  onApply: () => void;
  onCityChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onCountryChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onReset: () => void;
  onStateChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  values: LocationFilterValues;
};

const LocationFilterDropdown = ({
  onApply,
  onCityChange,
  onCountryChange,
  onReset,
  onStateChange,
  values,
}: LocationFilterDropdownProps): JSX.Element => {
  return (
    <div className={styles.filterDropdown}>
      <Input
        className={styles.filterInput}
        onChange={onCountryChange}
        placeholder="Country"
        value={values.country}
      />

      <Input
        className={styles.filterInput}
        onChange={onStateChange}
        placeholder="State"
        value={values.state}
      />

      <Input
        className={styles.filterInput}
        onChange={onCityChange}
        placeholder="City"
        value={values.city}
      />

      <Space>
        <Button
          icon={<SearchOutlined />}
          onClick={onApply}
          size="small"
          type="primary"
        >
          Search
        </Button>

        <Button onClick={onReset} size="small">
          Reset
        </Button>
      </Space>
    </div>
  );
};

export default LocationFilterDropdown;
